import React from "react";
import AllSubjectTopics from "../../topics/AllSubjectTopics";


function NcertSolutionPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="ncertsolution" />

    </>
  );
}

export default NcertSolutionPhysTopics;